import { NavLink } from 'react-router-dom'
import { NavBack } from '../components/nav-back'

export const SelectNewFormView = () => {
  return (
    <div className='main_content experience_content experience_content-alt'>
      <NavBack />
      <div>
        <h1 className='heading-styled'>Select a template</h1>
        <div>
          <NavLink to={'/templates'} viewTransition>
            <span className='material-symbols-rounded'>search</span>
            <span>Browse templates</span>
          </NavLink>
          <NavLink to={'/form/new/edit'} viewTransition>
            <span>Blank form</span>
            <span className='material-symbols-rounded'>arrow_right_alt</span>
          </NavLink>
        </div>
      </div>
    </div>
  )
}
